import { gql } from "@apollo/client";

export const EXPORT_WAREHOUSE_LOCATION_LIST = gql`
    mutation ExportWarehouseLocationList($locationIds: [Long!]!, $language: String, $timeZone: String) {
        exportWarehouseLocationList(locationIds: $locationIds, language: $language, timeZone: $timeZone)
    }
`;

export interface ExportWarehouseLocationListResponse {
    exportWarehouseLocationList: string;
}

